export default __webpack_public_path__ + "notsupport8dc265.png";